import React, { useEffect, useState } from 'react';
import './css/Customer.css';
import { firestore } from '../firebase';

function Customer({ customer }) {
  const [customerIds, setCustomerIds] = useState([]);
  const [theCustomers, setTheCustomers] = useState([]);
  const [matchedCustomers, setMatchedCustomers] = useState([]);

  const date = customer?.joined?.toDate();
  const formattedDate = date?.toLocaleDateString();

  useEffect(() => {
    const userStoriesRef = firestore.collection('orders');

    const unsubscribe = userStoriesRef.onSnapshot((querySnapshot) => {
      const ids = [];
      const userStoriesData = [];

      querySnapshot.forEach((doc) => {
        ids.push(doc.id);
        const data = doc.data();
        userStoriesData.push(data);
      });

      setCustomerIds(ids);
      setTheCustomers(userStoriesData);
    });

    return () => {
      unsubscribe();
    };
  }, []);

  useEffect(() => {
    const matchingCustomers = theCustomers.filter(
      (order) => order?.name === customer?.name && order?.status === "Delivered"
    );
    setMatchedCustomers(matchingCustomers);
  }, [customer, theCustomers]);

  return (
    <div className='customer'>
      <p>{customer?.name}</p>
      <p>{customer?.email}</p>
      <p>{formattedDate}</p>
      <p>{matchedCustomers.length} Orders</p>
    </div>
  );
}

export default Customer;